enum BillOfLadingPrintInstructions {
  SEA_WAYBILL = 'sea_waybill',
  ORIGINAL_BILL_OF_LADING = 'original_bill_of_lading',
}

export default BillOfLadingPrintInstructions;
